import { render } from "./CustomCategoryFolderListView.vue?vue&type=template&id=36692c0e&scoped=true&ts=true"
import script from "./CustomCategoryFolderListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryFolderListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryFolderListView.vue?vue&type=style&index=0&id=36692c0e&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36692c0e"]])

export default __exports__